import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import Modal from './Modal';

function ContentInacessibleModal({ t, closeModal }) {
  return (
    <Modal id="completed-order-modal" tabIndex={null}>
      <div
        className="modal-dialog modal-dialog-centered modal-journey"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="m--font-inverse-primary">
              {t('academy.modal.cantAccess')}
            </h3>
          </div>
          <div className="modal-body">
            <div className="modal-text">
              <div>{t('academy.modal.insufficientRights')}</div>
            </div>
          </div>
          <div className="modal-footer">
            <div className="footer-buttons">
              <div className="footer-single-button">
                <button
                  type="button"
                  className="btn m-btn--pill btn-dynamic btn-success-modal"
                  onClick={closeModal}
                >
                  {t('continue')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ContentInacessibleModal.propTypes = {
  t: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default translate(ContentInacessibleModal);
